import { FC } from 'react';

import { SummarySection } from 'features/Croptimizer/components/SummarySection/SummarySection';

import { BoardStep } from './components/BoardSteps/BoardSteps';

interface CroptimizerBoardProps {
  isPDF?: boolean;
}

const CroptimizerBoard: FC<CroptimizerBoardProps> = ({ isPDF = false }) => (
  <div>
    <SummarySection isPDF={isPDF} />
    <BoardStep isPDF={isPDF} />
  </div>
);

export default CroptimizerBoard;
